declare const __TUNETOSS_API_BASE_URL__: string

/** Empty for the browser build and the production HTTPS origin for native builds. */
export const API_BASE_URL = __TUNETOSS_API_BASE_URL__
export const IS_NATIVE_APP = API_BASE_URL.length > 0

/** Resolves server paths against the remote API only in native builds. */
export function apiUrl(path: string): string {
	if (!API_BASE_URL) return path
	return new URL(path, `${API_BASE_URL}/`).toString()
}

declare const __TUNETOSS_APP_VERSION__: string | undefined
declare const __TUNETOSS_BUNDLE_COMMIT__: string | undefined

// Test bundles may omit these defines, so guard with typeof.
export const APP_VERSION =
	typeof __TUNETOSS_APP_VERSION__ === 'string'
		? __TUNETOSS_APP_VERSION__
		: 'dev'
export const BUNDLE_COMMIT =
	typeof __TUNETOSS_BUNDLE_COMMIT__ === 'string'
		? __TUNETOSS_BUNDLE_COMMIT__
		: 'unknown'
